import BankAccountConnectionMethodModal from "./BankAccountConnectionMethodModal";

export default BankAccountConnectionMethodModal;
